module.exports = __webpack_public_path__ + "img/game5d_blank.ecbed501.png";